import React, { FC } from 'react';
import { Box, Button, Flex } from '@radix-ui/themes';
import './OpenBlog.css';

interface OpenBlogProps { }

const OpenBlog: FC<OpenBlogProps> = () => (
  <Box className="OpenBlog" data-testid="OpenBlog">
    <Button asChild className="open-blog-btn open-blog-btn-circle" variant="ghost">
      <a href="https://blog.zfir.dev" target="_blank" rel="noopener noreferrer" aria-label="Visit Blog">
        <Flex align="center" justify="center">
          <i className="fa-solid fa-blog"></i>
        </Flex>
      </a>
    </Button>
  </Box>
);

export default OpenBlog;
